import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// State
const state = () => ({
  roleValuesData: {},
  searchTab: "",
});

// getters
const getters = {
  getRoleValuesData: (state) => state.roleValuesData,
  getSearchTab: (state) => state.searchTab,
};

// actions
const actions = {};

// mutations
const mutations = {
  saveRoleValuesData(state, payload) {
    state.roleValuesData = payload;
  },

  saveSearchTab(state, payload) {
    state.searchTab = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
